/** 华奋达音乐律动勾选准备串行闸门（setMusicData 0x35 须在此之后） */

let selectionSetupChain: Promise<void> = Promise.resolve();
const selectionSetupTargets = new Set<string>();

export function isHfdRhythmSelectionSetupInFlight(targetId?: string): boolean {
  if (targetId) return selectionSetupTargets.has(targetId);
  return selectionSetupTargets.size > 0;
}

export function waitForHfdRhythmSelectionSetupIdle(): Promise<void> {
  return selectionSetupChain;
}

export function markHfdRhythmSelectionSetupTargetStart(targetId: string): void {
  selectionSetupTargets.add(targetId);
}

export function markHfdRhythmSelectionSetupTargetEnd(targetId: string): void {
  selectionSetupTargets.delete(targetId);
}

/** 串行化勾选准备（bind / 快照 / 切律动模式） */
export function runHfdRhythmSelectionSetupSerialized<T>(
  fn: () => Promise<T>
): Promise<T> {
  const next = selectionSetupChain.then(fn, fn);
  selectionSetupChain = next.then(
    () => undefined,
    () => undefined
  );
  return next;
}

export function resetHfdRhythmSelectionSetupGate(): void {
  selectionSetupChain = Promise.resolve();
  selectionSetupTargets.clear();
}
